import {
  CommonAPIClient,
  AccountsAPIClient,
  PaymentsAPIClient,
  WalletAPIClient
} from './api-client'

/**
 * Common API Client instance
 * @description The instance has to be initialized before use with `initialize(configuration)` method.
 * Configuration should contain all the required API back-end details.
 */
export const CommonAPI = new CommonAPIClient()

/**
 * Accounts API Client instance
 */
export const AccountsAPI = new AccountsAPIClient()

/**
 * Payments API Client instance
 */
export const PaymentsAPI = new PaymentsAPIClient()

/**
 * Wallet API Client instance
 */
export const WalletAPI = new WalletAPIClient()

/**
 * API identifiers
 */
export const APIs = {
  Common: 'common',
  Accounts: 'accounts',
  Payments: 'payments',
  Wallet: 'wallet'
}

/**
 * API directory
 */
export const API = {
  // Service keys, as specified in client's configuration.services
  [APIs.Common]: CommonAPI,
  [APIs.Accounts]: AccountsAPI,
  [APIs.Payments]: PaymentsAPI,
  [APIs.Wallet]: WalletAPI
}

/**
 * Registers an API client to be globally available.
 * Use in applets to register applet-specific API clients
 * @param {String} key API client key in the {@link APIs} enumeration
 * @param {APIClient} client API client to register
 */
export function useAPIClient (key, client) {
  if (!key) throw new Error('API client key is required')
  if (!client) throw new Error('API client is required')
  if (!client.name) throw new Error('API client name is required')

  if (APIs[key]) throw new Error(`API client [${key}] is already registered`)

  APIs[key] = client.name
  API[client.name] = client
}
